import React from "react";
export function Footer() {
  return <footer className="bg-brand-950 px-5 pb-32 pt-10 text-center text-brand-200 md:px-8 md:pb-12" data-id="element-154" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-3xl border-t border-white/10 pt-8" data-id="element-155" data-mp="3ggk7gsifd7yh">
        <p className="text-base font-extrabold text-white" data-id="element-156" data-mp="32ovuyo49khgz">Perimenopause Clinical Decision Roadmap™</p>
        <p className="mt-1 text-sm" data-id="element-157" data-mp="36qhdaozkhnyk">By Dr. Karito · © 2026. All rights reserved.</p>
        <p className="mt-6 text-xs leading-relaxed text-brand-300" data-id="element-158" data-mp="3uesczotj1hl9">
          <strong className="text-brand-200" data-id="element-159" data-mp="38quiv78flpl">Professional Disclaimer:</strong> This collection is intended for
          educational use by qualified healthcare professionals. It does not provide patient-specific medical advice,
          guarantee clinical outcomes, or replace independent clinical judgment, established guidelines, appropriate
          specialist consultation, or applicable professional regulations.
        </p>
      </div>
    </footer>;
}